// https://en.wikipedia.org/wiki/IETF_language_tag
var detectLanguage = function (allowedLanguages, defaultLanguage, preferredLanguage) {
    var languages = [navigator.language].concat(navigator.languages);
    if (preferredLanguage) {
        var preferredMatchingLanguage = allowedLanguages.find(function (language) { return language === preferredLanguage; });
        if (preferredMatchingLanguage) {
            return preferredLanguage;
        }
    }
    var matchingLanguage = languages.find(function (language) {
        var countrySplit = language.split("-");
        return allowedLanguages.includes(countrySplit[0]);
    });
    return matchingLanguage ? matchingLanguage.split("-")[0] : defaultLanguage;
};
export var LanguageHelper = {
    detectLanguage: detectLanguage,
};
//# sourceMappingURL=language.helper.js.map